import {Box, Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {filter, flow, get, includes, map} from '@yandex-delivery/utils'
import {type FC, type ReactNode, Children} from 'react'

import {AddressWidget, PickupWidget} from '../Address/desktop'
import {renderWidget} from '../index@desktop'
import {
  type AddressWidgetConfig,
  type SectionProps as Props,
  type SlotWidgetConfig,
  type WidgetConfig,
  WidgetType,
} from '../types'

export const Route: FC<Props> = flow(
  get('section.widgets'),
  filter((widget: WidgetConfig): widget is AddressWidgetConfig => widget.type === WidgetType.ADDRESS),
  map((widget: AddressWidgetConfig): ReactNode => {
    return (
      <Grid xs={12} item>
        <Paper padding="none" radius="L">
          <Grid container>
            <Grid xs={12} item>
              <Box ml="s" mt="s">
                {renderWidget(toHeaderWidget(widget))}
              </Box>
            </Grid>
            <Grid xs={12} item>
              {isPickupWidget(widget) ? <PickupWidget config={widget} /> : <AddressWidget config={widget} />}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }),
  Children.toArray,
)
Route.displayName = 'RouteDesktop'

function toHeaderWidget(widget: AddressWidgetConfig): SlotWidgetConfig {
  return {
    widget_id: `${widget.widget_id}.header`,
    type: WidgetType.SLOT,
    slot: {
      lead: widget.selected_lead,
      body1: {
        align: 'leading',
        title: {
          items: widget.selected_description.items.map(item => ({
            ...item,
            font_size: 20,
            font_weight: 'medium',
            color: 'textMain',
          })),
        },
      },
    },
  }
}

const isPickupWidget: (widget: AddressWidgetConfig) => boolean = flow(
  get('widget_id'), //
  includes('ndd'),
)
